import type { LearningItemView } from '../api/content.types';

/**
 * Mặt trước/sau của 1 thẻ flashcard theo `itemType` — dùng chung cho màn ôn SRS
 * và màn flashcard duyệt tự do (không đụng lịch SRS).
 */
export function FlashcardFront({ item }: { item: LearningItemView }) {
  if (item.itemType === 'VOCAB') {
    return (
      <>
        {item.kanji && <span style={{ fontFamily: 'var(--font-jp)', fontSize: 15, color: 'var(--text-secondary)' }}>{item.kana}</span>}
        <span style={{ fontFamily: 'var(--font-jp)', fontSize: item.kanji ? 56 : 68, lineHeight: 1.15, textAlign: 'center', color: 'var(--ink)' }}>
          {item.kanji ?? item.kana}
        </span>
      </>
    );
  }
  if (item.itemType === 'GRAMMAR') {
    return <span style={{ fontFamily: 'var(--font-jp)', fontSize: 28, fontWeight: 500, textAlign: 'center', color: 'var(--ink)' }}>{item.title}</span>;
  }
  if (item.itemType === 'KANJI') {
    // "Từ vựng Kanji" là CỤM từ (vd "会社員"), không phải 1 glyph đơn như KANA/RADICAL —
    // cỡ nhỏ hơn và cho xuống dòng để không bị cắt.
    return (
      <span style={{ fontFamily: 'var(--font-jp)', fontSize: 40, lineHeight: 1.15, textAlign: 'center', color: 'var(--ink)' }}>{item.character}</span>
    );
  }
  return <span style={{ fontFamily: 'var(--font-jp)', fontSize: 84, lineHeight: 1.1, textAlign: 'center', color: 'var(--ink)' }}>{item.character}</span>;
}

export function FlashcardBack({ item }: { item: LearningItemView }) {
  if (item.itemType === 'VOCAB') {
    return <span style={{ fontSize: 22, fontWeight: 600, textAlign: 'center', color: 'var(--ink)' }}>{item.meaningVi}</span>;
  }
  if (item.itemType === 'GRAMMAR') {
    return (
      <span style={{ display: 'flex', flexDirection: 'column', gap: 8, textAlign: 'center' }}>
        {item.meaningVi && <span style={{ fontSize: 22, fontWeight: 600, color: 'var(--ink)' }}>{item.meaningVi}</span>}
        <span style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.55 }}>{item.bodyMarkdown}</span>
      </span>
    );
  }
  if (item.itemType === 'KANJI') {
    // Dữ liệu nguồn chỉ có 1 cách đọc mỗi từ, KHÔNG phân biệt được on/kun-yomi —
    // hiện thẳng, không gắn nhãn sai.
    const reading = item.kunYomi ?? item.onYomi;
    return (
      <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
        {reading && <span style={{ fontFamily: 'var(--font-jp)', fontSize: 20, color: 'var(--text-secondary)' }}>{reading}</span>}
        {item.meaningVi && <span style={{ fontSize: 16, color: 'var(--ink)' }}>{item.meaningVi}</span>}
      </span>
    );
  }
  return (
    <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
      {item.romaji && <span style={{ fontSize: 20, color: 'var(--text-secondary)' }}>{item.romaji}</span>}
      {item.meaningVi && <span style={{ fontSize: 16, color: 'var(--ink)' }}>{item.meaningVi}</span>}
    </span>
  );
}
